const PageTransactionsBatch = () => import('./PageTransactionsBatch');

export default {
  name: 'transactionsBatch',
  path: 'transactions-batch/:name?/:total?/:dm_id?',
  params: {
    name: null,
    total: null,
  },
  meta: {
    title: 'Busca por Lote',
  },
  component: PageTransactionsBatch,
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-order/features/transactions-batch/routes.js